<template>
  <div>
    <div class="live-wrap">
      <calendar ref="calendar" class="calendar" @selectDateClick="selectDateClick" @selectMonth="selectMonth"></calendar>
      <live-rooms class="liverooms" :liveRooms="liveRooms"></live-rooms>
    </div>
  </div>
</template>

<script>
import dateUtils from '@/common/dateUtils.js'
import Calendar from '@/components/live/Calendar'
import LiveRooms from '@/components/live/Liverooms'
export default {
  name: 'LiveCalendar',
  components: {Calendar, LiveRooms},
  data () {
    return {
      liveRooms: []
    }
  },
  methods: {
    selectDateClick: function (day) {
      // 请求当前时间课程数据 day 是返回当前数据字符   2019-12-12
      // http://localhost:8080/classSvr/api/v1/user/liveinfo?usertype=0&start=2019-12-13&end=2019-12-13
      let data = {
        usertype: this.$store.getters.getUserType,
        start: day,
        end: day
      }
      this.$api.liveServer.getUserLiveInfos(data).then(res => {
        if (res.code !== 0) {
          this.liveRooms = []
          return
        }
        if (res.lives) {
          res.lives.forEach(live => {
            live.teachers = JSON.parse(live.teachers)
          })
          // 排序，正序
          let arrayOrder = res.lives.sort(function (a, b) {
              return (a.begin_time <= b.begin_time ? -1 : 1);
          })
          this.liveRooms = arrayOrder
        } else {
          this.liveRooms = []
        }
      })
    },
    selectMonth: function (year, month) {
      // 请求当月得打点数据
      // http://localhost:8080/classSvr/api/v1/user/live?usertype=0&start=2019-11-24&end=2020-01-07
      let start = dateUtils.formatDate(year, month - 1, 24)
      if (month - 1 === 0) {
        start = dateUtils.formatDate(year - 1, 12, 24)
      }
      let end = dateUtils.formatDate(year, month + 1, 7)
      if (month + 1 === 13) {
        end = dateUtils.formatDate(year + 1, 1, 7)
      }
      let requestData = {usertype: this.$store.getters.getUserType, start: start, end: end}
      this.$api.liveServer.getUserHasLiveDates(requestData).then(res => {
        if (res.code === 0) {
          let livePoint = res.livedate
          this.$refs.calendar.updatePointData(livePoint)
        }
      })
    }

  }
}
</script>

<style scoped>
  .calendar{
    height: 550px;
    float: left;
    overflow: auto;
  }

  .live-wrap{
    display: flex;
    flex-direction: row;
  }
  .liverooms{
    flex: 1;
    margin-left: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/page/live/LiveCalendar.vue